import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, trackSessionStart, trackSessionEnd } from '../utils/analytics';

const GATracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4 on app start
    const gaInitialized = initGA();
    
    if (gaInitialized) {
      // Track session start
      trackSessionStart();
      
      // Track initial page view
      trackPageView(location.pathname + location.search, document.title);
      
      // Track session end on page unload
      const handleBeforeUnload = () => {
        trackSessionEnd();
      };
      
      window.addEventListener('beforeunload', handleBeforeUnload);
      
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, []); // Run once on mount

  useEffect(() => {
    // Track page views on route changes
    if (window.gtag) {
      trackPageView(location.pathname + location.search, document.title);
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default GATracker;